module.exports = __webpack_public_path__ + "media/components/country-flag/static/tn-6a1184680a83ae1f69cb2952b93d9354.svg";